import { HolidayFilterParams } from '@/types/admin-holiday';
import { japaneseDateToISO } from '@/utils/dateConverter';

export const getCurrentYearHolidayDefaults = (baseDate = new Date()) => {
  const year = baseDate.getFullYear();

  return {
    start_date: `${year}-01-01`,
    end_date: `${year}-12-31`,
  };
};

export const normalizeHolidayFilters = (
  filters: HolidayFilterParams,
  baseDate = new Date()
): Required<HolidayFilterParams> => {
  const defaults = getCurrentYearHolidayDefaults(baseDate);

  return {
    holiday_name: filters.holiday_name?.trim() || '',
    start_date: filters.start_date?.trim() || defaults.start_date,
    end_date: filters.end_date?.trim() || defaults.end_date,
  };
};

export const buildHolidaySearchParams = (
  filters: HolidayFilterParams,
  baseDate = new Date()
): URLSearchParams => {
  const normalizedFilters = normalizeHolidayFilters(filters, baseDate);
  const params = new URLSearchParams();

  Object.entries(normalizedFilters).forEach(([key, value]) => {
    if (!value) return;

    if (key === 'start_date' || key === 'end_date') {
      params.set(key, japaneseDateToISO(value) || value);
      return;
    }

    params.set(key, value);
  });

  return params;
};
